import React from "react";

/**
 * Small logo-inspired brand motifs (hexagonal/star geometry from the
 * HuddleUp mark). Use as corner brackets, section anchors, dividers.
 * All 1px gold linework, no fills, pure editorial detail.
 */

const STROKE = "#C9A961";

// Corner bracket — top-left and bottom-right style, used to frame stat blocks
export function CornerBracket({ position = "tl", size = 22 }) {
  const points = {
    tl: "M 12 0 L 0 0 L 0 12",
    tr: "M 0 0 L 12 0 L 12 12",
    bl: "M 0 0 L 0 12 L 12 12",
    br: "M 12 0 L 12 12 L 0 12",
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      stroke={STROKE}
      strokeWidth="0.8"
      aria-hidden="true"
    >
      <path d={points[position]} />
    </svg>
  );
}

// Small hex mark — echoes the outer shape of the logo geometry
export function HexMark({ size = 20 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke={STROKE}
      strokeWidth="0.9"
      aria-hidden="true"
    >
      <polygon points="16,3 28,10 28,22 16,29 4,22 4,10" />
      <polygon points="16,9 23,13 23,19 16,23 9,19 9,13" opacity="0.65" />
      <circle cx="16" cy="16" r="1.2" fill={STROKE} />
    </svg>
  );
}

// Diamond glyph — used as editorial chapter mark
export function DiamondMark({ size = 12 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      stroke={STROKE}
      strokeWidth="1"
      aria-hidden="true"
    >
      <polygon points="6,1 11,6 6,11 1,6" />
      <line x1="1" y1="6" x2="11" y2="6" opacity="0.5" />
      <line x1="6" y1="1" x2="6" y2="11" opacity="0.5" />
    </svg>
  );
}

// A wrapping frame for stat/hero blocks — 4 corner brackets
export function BracketFrame({ children, className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <div className="absolute -top-2 -left-2 z-10"><CornerBracket position="tl" /></div>
      <div className="absolute -top-2 -right-2 z-10"><CornerBracket position="tr" /></div>
      <div className="absolute -bottom-2 -left-2 z-10"><CornerBracket position="bl" /></div>
      <div className="absolute -bottom-2 -right-2 z-10"><CornerBracket position="br" /></div>
      {children}
    </div>
  );
}
